import { FC, ReactNode, useCallback, useRef, SyntheticEvent } from 'react'

import { useOnClickOutside } from '../../hooks/useClickOutside'

import * as SC from './styled'

export type BottomPanelProps = {
  isOpen?: boolean
  toggleBottomPanelFunction?: (ev: SyntheticEvent) => void
  heading: ReactNode
}

const BottomPanel: FC<BottomPanelProps> = ({
  children,
  isOpen,
  toggleBottomPanelFunction,
  heading,
}) => {
  const ref = useRef<any>()
  const togglePanelHandler = useCallback(
    (ev) => {
      if (isOpen) {
        toggleBottomPanelFunction?.(ev)
      }
    },
    [isOpen, toggleBottomPanelFunction]
  )

  useOnClickOutside(ref, togglePanelHandler)

  return (
    <SC.BottomPanel isOpen={isOpen} ref={ref}>
      <SC.Heading>
        {heading}
        <SC.CloseButton
          icon="close"
          variantType="button"
          variantColorScheme="black"
          variantIcon="only"
          actionProps={{
            onClick: (ev) => togglePanelHandler(ev),
            'aria-label': 'Fermer les valeurs nutritionnelles',
          }}
        />
      </SC.Heading>
      <SC.Content>{children}</SC.Content>
    </SC.BottomPanel>
  )
}

export default BottomPanel
